'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getElementDropPosition = exports.getElementOffset = exports.isNewElement = exports.getElementDragOrigin = exports.getNewLineDragOrigin = exports.getBoardIconCentreOffset = exports.dropTargetAlreadyHandled = undefined;

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash');

var _elementHelper = require('../../../common/elements/elementHelper');

var _point = require('../../../common/maths/geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _boardConstants = require('../../../common/boards/boardConstants');

var _lineConstants = require('../../../common/lines/lineConstants');

var _dndConstants = require('./dndConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This helper function determines if a child component has already handled the drop event.
 * NOTE: The child component MUST add a 'handledBy' property to the drop result in order for this to work.  The child
 * must also be a DOM child of the element in order for this to work.
 *
 * @param monitor {DropTargetMonitor} The React DnD drop target monitor.
 * @param component {ReactComponent} The React component that intends to handle the drop.
 * @returns {boolean} True if a child component has already handled the drop.
 */
var dropTargetAlreadyHandled = exports.dropTargetAlreadyHandled = function dropTargetAlreadyHandled(monitor, component) {
    var domNode = _reactDom2.default.findDOMNode(component);
    var lastDropResult = monitor.getDropResult();
    return lastDropResult && lastDropResult.handledBy && domNode.contains(lastDropResult.handledBy);
};

// Item predicates


// Constants


// Utils
// Lib
var sourceIsBoardInList = function sourceIsBoardInList(_ref) {
    var item = _ref.item;
    return item.fromList && (0, _elementHelper.isBoardLike)(item.element);
};

var sourceIsNewLine = function sourceIsNewLine(_ref2) {
    var item = _ref2.item;
    return item.isCreate && (0, _elementHelper.isLine)(item.element);
};

// Drag offsets
var getBoardIconCentreOffset = exports.getBoardIconCentreOffset = function getBoardIconCentreOffset(_ref3) {
    var gridSize = _ref3.gridSize;
    return pointLib.getPoint(_boardConstants.DEFAULT_BOARD_WIDTH * gridSize / 2, _boardConstants.DEFAULT_BOARD_WIDTH * gridSize / 2);
};

var getBoardInListDragOrigin = getBoardIconCentreOffset;

var getNewLineDragOrigin = exports.getNewLineDragOrigin = function getNewLineDragOrigin(_ref4) {
    var gridSize = _ref4.gridSize;
    return pointLib.getPoint(_lineConstants.DEFAULT_LINE_WIDTH * gridSize / 2, _lineConstants.DEFAULT_LINE_HEIGHT * gridSize / 2);
};

var getDefaultDragOrigin = function getDefaultDragOrigin(_ref5) {
    var initialSourceClientOffset = _ref5.initialSourceClientOffset,
        initialClientOffset = _ref5.initialClientOffset;
    return pointLib.difference(initialSourceClientOffset, initialClientOffset);
};

var getElementDragOrigin = exports.getElementDragOrigin = (0, _lodash.cond)([[sourceIsBoardInList, getBoardInListDragOrigin], [sourceIsNewLine, getNewLineDragOrigin], [_lodash.stubTrue, getDefaultDragOrigin]]);

var isNewElement = exports.isNewElement = function isNewElement(_ref6) {
    var item = _ref6.item;
    return item.isCreate;
};

var isGrabbedElement = function isGrabbedElement(_ref7) {
    var grabbedElement = _ref7.grabbedElement,
        element = _ref7.element;
    return grabbedElement.get('id') === element.get('id');
};

var getGrabOffset = function getGrabOffset(_ref8) {
    var clientOffset = _ref8.clientOffset,
        sourceClientOffset = _ref8.sourceClientOffset;
    return pointLib.difference(sourceClientOffset, clientOffset);
};

var getGrabbedBoardInListOffset = function getGrabbedBoardInListOffset(_ref9) {
    var clientOffset = _ref9.clientOffset,
        sourceClientOffset = _ref9.sourceClientOffset,
        gridSize = _ref9.gridSize;
    return pointLib.difference(getBoardInListDragOrigin({ gridSize: gridSize }), getGrabOffset({ clientOffset: clientOffset, sourceClientOffset: sourceClientOffset }));
};

// The grabbed element might need to be translated
var getGrabbedElementTranslation = function getGrabbedElementTranslation(_ref10) {
    var grabbedElement = _ref10.grabbedElement,
        clientOffset = _ref10.clientOffset,
        sourceClientOffset = _ref10.sourceClientOffset,
        gridSize = _ref10.gridSize;

    if ((0, _elementHelper.isBoardLike)(grabbedElement) && (0, _elementHelper.isInList)(grabbedElement)) {
        return getGrabbedBoardInListOffset({ clientOffset: clientOffset, sourceClientOffset: sourceClientOffset, gridSize: gridSize });
    }
    return _dndConstants.NO_DRAG_OFFSET;
};

var grabbedElementRequiresOffset = function grabbedElementRequiresOffset(grabbedElement) {
    return (0, _elementHelper.isBoardLike)(grabbedElement) && (0, _elementHelper.isInList)(grabbedElement);
};

var offsetHasBeenUpdated = function offsetHasBeenUpdated(offset) {
    return !pointLib.equals(offset, _dndConstants.NO_DRAG_OFFSET);
};

/**
 * NOTE: This is also used by the ElementDragPreviewPositioner, which is why it needs both the item and the element
 * to figure out if the element is the "grabbedElement".
 */
var getElementOffset = exports.getElementOffset = function getElementOffset(_ref11) {
    var item = _ref11.item,
        element = _ref11.element,
        clientOffset = _ref11.clientOffset,
        sourceClientOffset = _ref11.sourceClientOffset,
        gridSize = _ref11.gridSize;
    var offsetsMap = item.offsetsMap;

    var elementId = element.get('id');
    var offset = offsetsMap[elementId];
    var grabbedElement = item.element;

    // Need to account for when the grabbed element needs a translation based on the grab position, such as when
    // a board is in a list.
    // FIXME This is a hack because we don't have the clientOffset & sourceClientOffset when creating the
    // offset map.  It simply makes sure that the offset map has an offset for the grabbed element when it's
    // a board in a list.
    if (isGrabbedElement({ grabbedElement: grabbedElement, element: element }) && grabbedElementRequiresOffset(grabbedElement) && !offsetHasBeenUpdated(offset)) {
        // Setting to the offsetsMap.  This should only ever happen once
        offsetsMap[elementId] = getGrabbedElementTranslation({
            grabbedElement: item.element,
            clientOffset: clientOffset,
            sourceClientOffset: sourceClientOffset,
            gridSize: gridSize
        });
    }

    return offsetsMap[elementId] || _dndConstants.NO_DRAG_OFFSET;
};

var getNewElementDropPosition = function getNewElementDropPosition(_ref12) {
    var item = _ref12.item,
        clientOffset = _ref12.clientOffset,
        sourceClientOffset = _ref12.sourceClientOffset,
        gridSize = _ref12.gridSize;

    // Then add the offset of the dragged element
    var element = item.element;

    var offset = getElementOffset({ item: item, element: element, clientOffset: clientOffset, sourceClientOffset: sourceClientOffset, gridSize: gridSize });

    // Get mouse up location (clientOffset instead of sourceClientOffset) for new elements
    return pointLib.translate(clientOffset, offset);
};

var getMovedElementDropPosition = function getMovedElementDropPosition(_ref13) {
    var sourceClientOffset = _ref13.sourceClientOffset;
    return sourceClientOffset;
};

var getElementDropPosition = exports.getElementDropPosition = function getElementDropPosition(_ref14) {
    var item = _ref14.item,
        clientOffset = _ref14.clientOffset,
        sourceClientOffset = _ref14.sourceClientOffset,
        gridSize = _ref14.gridSize;
    return isNewElement({ item: item }) ? getNewElementDropPosition({ item: item, clientOffset: clientOffset, sourceClientOffset: sourceClientOffset, gridSize: gridSize }) : getMovedElementDropPosition({ sourceClientOffset: sourceClientOffset });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/dnd/dragAndDropUtils.js
// module id = 145
// module chunks = 0